import { NextPage } from 'next';

import { PasswordRecoveryProvider } from '~/modules/auth/hooks/usePasswordRecovery';

import { PasswordRecovery } from '~/modules/auth/pages/PasswordRecovery';

import { withAuthentication } from '~/shared/utils/withAuthentication';

export const getServerSideProps = withAuthentication();

const PasswordRecoveryPage: NextPage = () => {
  return (
    <PasswordRecoveryProvider>
      <PasswordRecovery />
    </PasswordRecoveryProvider>
  );
};

export default PasswordRecoveryPage;
